import React, {useState} from "react";
import {useTranslation} from "react-i18next";

import {useWorkgroupInfiniteQuery} from "./query";
import {debounce} from "../../../utils/debounce";

import MDInput from "materialDashboard/components/MDInput";

import Autocomplete from "@mui/material/Autocomplete";
import {getScrollHandler, LoadingAdornment} from "../utils";


const WorkgroupsAutocomplete = ({ selectedWorkgroups, setSelectedWorkgroups, workgroupFilters={}, fieldProps={}, ...props }) => {
    const {t} = useTranslation(["inputs"]);

    const [hasFocus, setHasFocus] = useState(false);
    const [workgroupSearch, setWorkgroupSearch] = useState("");
    const workgroupSearchQuery = useWorkgroupInfiniteQuery({search: workgroupSearch, order_by: "name", ...workgroupFilters}, hasFocus);

    const workgroupOptions = [
        ...selectedWorkgroups,
        ...(workgroupSearchQuery.data?.pages?.flatMap((page) => page.items) ?? []).filter((s) => !selectedWorkgroups.find(({id}) => id === s.id)),
    ]

    const handleWorkgroupSearch = debounce((value) => {
        setWorkgroupSearch(value);
    }, 300);

    return <Autocomplete
        multiple
        id="workgroup-autocomplete"
        options={workgroupOptions}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        getOptionLabel={(workgroup) => workgroup.name}
        value={selectedWorkgroups}
        defaultValue={selectedWorkgroups}
        filterOptions={(x) => x}
        loading={workgroupSearch.isFetching}
        onChange={(e, value) => setSelectedWorkgroups(value)}
        onClose={() => handleWorkgroupSearch("")}
        onFocus={() => setHasFocus(true)}
        onBlur={() => setHasFocus(false)}
        ListboxProps={{onScroll: getScrollHandler(workgroupSearchQuery)}}
        renderInput={(params) => (
            <MDInput {...params}
                     onChange={(e) => handleWorkgroupSearch(e.target.value)}
                     variant="standard"
                     label={t('workgroupsAutocomplete.label')}
                     placeholder={t('workgroupsAutocomplete.placeholder')}
                     InputProps={{
                         ...params.InputProps,
                         endAdornment: (<LoadingAdornment infiniteQuery={workgroupSearchQuery} params={params} /> ),
                     }}
                     {...fieldProps}
            />
        )}
        {...props}
    />
}

export default WorkgroupsAutocomplete;